module.exports = __webpack_public_path__ + "img/REnneris64_ua.2b44705a.webp";